import { ActionDoneType } from '@/enums/ActionDoneType.enum';
import { DateTimeFormatPipe } from '@/extensions/dateTimePipe';
import { AlertService } from '@/services/alert.service';
import { AppConfigService } from '@/services/app-config.service';
import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ActionState, PropertiesService, PropertyOpenDataStatus, RealProperty } from '@eemo/api-client';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

export class PropertyDataSyncDialogData {
  prop: RealProperty;
}

@Component({
  selector: 'app-property-data-sync-dialog',
  templateUrl: './property-data-sync-dialog.component.html',
  styleUrls: ['./property-data-sync-dialog.component.scss'],
  standalone: true,
  imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule, NgIf, NgFor, TranslateModule, DateTimeFormatPipe]
})
export class PropertyDataSyncDialogComponent implements OnInit, OnDestroy {
  dialogTitle = 'propertyDataSyncDialog.title';
  sub = new Subscription();
  syncSub = new Subscription();

  status: PropertyOpenDataStatus;
  detailsTitles = [];
  details: { [key: string]: string[] } = {};

  isDisabled = false;
  submitText = 'SYNC';
  timer: NodeJS.Timeout;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropertyDataSyncDialogData,
    public dialogRef: MatDialogRef<PropertyDataSyncDialogComponent>,
    private propertiesService: PropertiesService,
    private dialog: MatDialog,
    private alertService: AlertService,
    private appConfigService: AppConfigService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.stopAutoRefresh();
  }

  loadData() {
    this.sub = this.propertiesService.getRealPropertyOpenDataStatus(this.data.prop.uid).subscribe((s) => {
      this.detailsTitles = [];
      this.details = {};
      this.status = s.find((e) => true);
      let curKey = '';
      this.details[curKey] = [];
      this.status?.details?.forEach((d) => {
        if (d.startsWith('---')) {
          curKey = d.replace('---', '');
          this.detailsTitles.push(curKey);
          this.details[curKey] = [];
        } else {
          this.details[curKey].push(d);
        }
      });
      if (this.status?.state === ActionState.IN_PROGRESS) {
        this.isDisabled = true;
        this.startAutoRefresh();
      } else if (this.status) {
        this.submitText = 'RESTART';
        this.isDisabled = false;
        this.stopAutoRefresh();
      }
    });
  }

  startAutoRefresh() {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.loadData(), 10000);
  }

  stopAutoRefresh() {
    clearInterval(this.timer);
  }

  onSubmit() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      // width: '25rem',
      data: {
        message: 'Confirmez-vous le lancement de la sycnhronisation des données publiques?'
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.doSync();
        this.dialog.openDialogs.forEach((d) => d.close());
      }
    });
  }

  doSync() {
    this.syncSub = this.propertiesService.syncRealPropertyOpenData(this.data.prop.uid).subscribe(() => {
      this.alertService.success('Synchronisation des données publiques lancée');
      this.appConfigService.triggerActionDone(ActionDoneType.OPENDATA_SYNC);
    });
  }
}
